// profiles.store.js
import { observable, computed, action, toJS } from "mobx";

import { axios } from "../../utils/axios";

import { QuizQuestion } from "./quiz_objects/quiz-question";
import { QuizQuestionAnswer } from "./quiz_objects/quiz-question-answer";

import { QuizUserSubjectTracking } from "./subjects/quiz-user-subject-tracking";

export default class QuizzerStore {
    @observable question: any = {};
    @observable quiz_user_subject_tracking = new QuizUserSubjectTracking();
    @observable answer: any = undefined;
    @observable state = "pending"; // "pending" / "done" / "error"
    @observable errorSource = "";
    @observable errorTitle = "";
    @observable errorDetail = "";
    @observable user_is_done_quizzing_for_today = false;

    rootStore: any;

    constructor(rootStore: any) {
        this.rootStore = rootStore;
    }

    private setError(err: any, defaultTitle: string) {
        const response = err && err.response;
        const errorData = response && response.data ? response.data : {};

        this.errorSource = errorData.source || "quizzer";
        this.errorTitle = errorData.title || defaultTitle;
        this.errorDetail =
            errorData.detail || (err && err.message) || "Please try again.";
        this.state = "error";

        return response;
    }

    @action
    fetchAnswer(
        subject_user: string,
        subject_slug: string,
        question: QuizQuestion,
        answer: any,
        cb: Function
    ) {
        const store = this;
        store.state = "pending";

        const answerData = {
            question: question,
            userSelectedAnswer: answer
        };

        axios()
            .post(
                `/subjects/${subject_user}/${subject_slug}/actions/answer`,
                answerData
            )
            .then(function(res: any) {
                res.data.show_answer = true;
                store.answer = new QuizQuestionAnswer(res.data);
                console.log(res.data);
                console.log(store.answer);
                store.state = "done";
                cb(true);
            })
            .catch(function(err: any) {
                const response = store.setError(
                    err,
                    "Could not load this card's answer"
                );
                cb(false, "unknownError", response);
            });
    }

    @action
    fetchQuestion(
        subject_user: string,
        subject_slug: string,
        options: {},
        params: {},
        cb: Function
    ) {
        const store = this;
        store.answer = undefined;
        store.state = "pending";
                
        var selected_question_types = toJS(
            this.rootStore.uiStore.selectedQuestionTypes
        ).map((qt: any) => {
            return qt;
        });

        let algorithm = 'selectable';
        if (this.rootStore.uiStore.adaptable) {
            algorithm = 'adaptable';
        }

        var queryParams = {...options, ...{
            format: selected_question_types,
            algorithm: algorithm
        }}

        axios()
            .post(
                `/subjects/${subject_user}/${subject_slug}/actions/random_question`,
                params,
                {
                    params: queryParams
                }
            )
            .then(function(res: any) {
                res.data.show_answer = false;
                store.user_is_done_quizzing_for_today = res.data.user_is_done_quizzing_for_today; 
                store.question = new QuizQuestion(res.data);
                if (res.data.quiz_user_subject_tracking) {
                    store.quiz_user_subject_tracking = new QuizUserSubjectTracking(res.data.quiz_user_subject_tracking);
                }
                store.state = "done";
                cb(true, store.question);
            })
            .catch(function(err: any) {
                const response = store.setError(
                    err,
                    "Could not load the next question"
                );
                cb(false, "unknownError", response);
            });
    }
}
